import React from 'react'
import { useParams } from 'react-router-dom'

import { Page } from '../../components'
import { VehicleDetailsContainer } from '../../components/VehicleDetails/VehicleDetailsContainer'
import { VehicleDetailProvider } from '../../providers/VehicleDetailProvider/VehicleDetailProvider'

export default function VehicleDetails() {
  const { id: vehicleId } = useParams()

  return (
    <VehicleDetailProvider vehicleId={vehicleId!}>
      <Page title="Vehicle Detail">
        <VehicleDetailsContainer />
      </Page>
    </VehicleDetailProvider>
  )
}
